<template>
  <div class="xwdt-page">
    <div class="container">
      <div class="hero">
        <h1 class="title">新闻动态</h1>
        <p class="subtitle">聚焦基地最新资讯、活动信息与行业动态</p>
      </div>

      <div class="news-list">
        <div
          class="news-card"
          v-for="(item, index) in newsList"
          :key="index"
          @click="openUrl(item.url)"
        >
          <img class="cover" :src="getCover(item.img)" :alt="item.title" />
          <div class="news-content">
            <div class="tag">{{ item.tag || "新闻动态" }}</div>
            <div class="news-title">{{ item.title }}</div>
            <div class="news-desc">{{ item.content }}</div>
            <div class="news-time">{{ item.date }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newsData from "../assets/news.json";

export default {
  name: "Xwdt",
  data() {
    return {
      newsList: newsData,
    };
  },
  methods: {
    getCover(img) {
      try {
        return require(`../${img}`);
      } catch (e) {
        return require("../assets/img/home/9.webp");
      }
    },
    openUrl(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.xwdt-page {
  min-height: calc(100vh - 136px);
  background: #f7fbff;
  padding: 40px 0 64px;
}

.container {
  width: 1280px;
  margin: 0 auto;
}

.hero {
  text-align: center;
  margin-bottom: 28px;
}

.title {
  color: #045588;
  font-size: 42px;
  line-height: 1.3;
  font-weight: 700;
}

.subtitle {
  margin-top: 10px;
  color: #4b4f54;
  font-size: 16px;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.news-card {
  display: flex;
  align-items: stretch;
  gap: 18px;
  background: #fff;
  border: 1px solid #e6edf5;
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 8px 22px rgba(26, 64, 96, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.news-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(26, 64, 96, 0.12);
}

.cover {
  width: 240px;
  height: 140px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
}

.news-content {
  min-width: 0;
  flex: 1;
}

.tag {
  display: inline-block;
  font-size: 12px;
  color: #0f4f84;
  background: #eaf4ff;
  border-radius: 999px;
  padding: 4px 10px;
}

.news-title {
  margin-top: 12px;
  color: #1e2b3b;
  font-size: 22px;
  font-weight: 600;
}

.news-desc {
  margin-top: 8px;
  color: #4b4f54;
  font-size: 15px;
  line-height: 1.7;
}

.news-time {
  margin-top: 14px;
  color: #8293a3;
  font-size: 13px;
}

@media (max-width: 1360px) {
  .container {
    width: calc(100% - 48px);
  }
}

@media (max-width: 992px) {
  .news-card {
    flex-direction: column;
  }

  .cover {
    width: 100%;
    height: 190px;
  }
}
</style>
